import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { Fiat, IVSNFeeTokenCollection } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { CoreModule } from "@modules/core/core.module";
import { Web3Facade } from "@modules/web3/+state/web3.facade";

@Component({
	selector: "vision-fee-trans-detail-ui",
	imports: [CoreModule],
	templateUrl: "./vision-fee-trans-detail.component.html",
	standalone: true,
	styleUrl: "./vision-fee-trans-detail.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisionFeeTransDetailComponent {
	vsnFeeCollection = input<IVSNFeeTokenCollection>(null);
	fee = input<number>(0);
	fiat = input<Fiat>(null);
	tradable = input<Tradable>(null);
	type = input<TRADE_TYPE>(TRADE_TYPE.BUY);

	private facade = inject(Web3Facade);
	vision$ = this.facade.getVisionTradable$();
}
